export function Logo() {
  return (
    <a className="cs-logo" href="/" aria-label="Calendar Studio homepage">
      <span className="cs-logo-mark">C<span>S</span></span>
      <span className="cs-logo-text">Calendar<br />Studio</span>
    </a>
  );
}
